import { AxiosError } from 'axios';
import {
  transmitInvoiceDicionaryErrorField,
  transmitInvoiceDicionaryErrorValue,
} from '..';
import { Modal, Table, notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';

const columns = [
  {
    title: 'Campo',
    dataIndex: 'field',
    key: 'field',
    width: '50%',
  },
  {
    title: 'Mensagem',
    dataIndex: 'value',
    key: 'value',
    width: '50%',
  },
];

interface ErrorData {
  error: {
    message: string;
    data: { fields: Record<string, string>; cpfCnpj: string };
  };
  message: string;
}

function invoiceHandleError(error: unknown) {
  const err = error as AxiosError<ErrorData>;

  if (
    err.response?.data.error.message ===
    'Não localizamos qualquer Empresa com os parâmetros informados'
  ) {
    return notification.error({
      message: `${err.response?.data.error.message}: CNPJ-${err.response?.data.error.data.cpfCnpj}`,
    });
  }

  if (err.response?.data.message) {
    return notification.error({ message: err.response?.data.message });
  }

  if (err.response?.data.error.message) {
    notification.error({
      message: 'Impossibilidade de envio',
      description:
        transmitInvoiceDicionaryErrorValue[err.response?.data.error.message] ||
        err.response?.data.error.message,
    });
  } else {
    notificationError(err.response?.data);
  }

  if (err.response) {
    const errors = err.response.data.error.data;

    if (errors?.fields) {
      const hasErros = Object.keys(errors).some((key) => !!key);

      if (hasErros) {
        const newErros = [];
        for (const key in errors?.fields) {
          if (errors.fields[key]) {
            newErros.push({
              field:
                transmitInvoiceDicionaryErrorField[
                  key
                    .replace(/itens\[(\d+)\]\./, '')
                    .replace(/documento\[(\d+)\]\./, '')
                    .replace(/servico\[(\d+)\]\./, '')
                ] || key,
              value:
                transmitInvoiceDicionaryErrorValue[errors.fields[key]] ||
                errors.fields[key],
            });
          }
        }

        Modal.confirm({
          width: '80%',
          title: 'Campos necessários para a transmissão da nota.',
          content: (
            <Table
              className="table-small"
              dataSource={newErros}
              columns={columns}
              pagination={false}
              scroll={{ x: true }}
            />
          ),
          okText: 'Fechar',
          cancelButtonProps: { hidden: true },
        });
      }
    }
  }
}

export default invoiceHandleError;
